/**
 * 
 * THIS FILE IS CURRENTLY UNUSED.
 * THIS IS A VIEW WHERE YOU MAY ORDER ARTICLES FROM OTHER VENUES ION THE COMPANY.
 * IT WAS BUILT FOR FABRIQUE. BUT STOPPED BEING USED.
 * LEFT IN CASE WE NEED TO BUILD SOMETHING SIMILAR IN THE FUTURE.
 * 
 */



import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useInventoryUniverse } from '~Components/InventoryUniverse';
import { useI18n } from '~Hooks';
import gql from 'graphql-tag';
import CreateOrder from './Components/CreateOrder';
import OrdersList from './Components/OrdersList';
import TextBlock from './Components/TextBlock';
import { useQuery } from '@apollo/client';

const Wrapper = styled.div`
  padding: 40px;
  margin: 0 auto;
  max-width: 754px;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
`;

const PageHeader = styled.div`
  color: #1c232c;
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 48px;
  text-align: center;
`;

const ITEMS_QUERY = gql`
  query getItems($venueId: ID!) {
    venue: Venue(id: $venueId) {
      id
      name
      company {
        id
        name
        items {
          id
          title
        }
      }
    }
  }
`;

const InventoryOrder = () => {
  const [, , venueId] = location.hash.split('/');
  const { i18n } = useI18n();
  const universe = useInventoryUniverse();
  const [showCreateView, setShowCreateView] = useState(false);

  const { data, loading } = useQuery(ITEMS_QUERY, {
    variables: {
      venueId,
    },
  });

  const venueItems = data?.venue?.company?.items ?? [];

  return (
    <Wrapper>
      <PageHeader>{i18n('Inventory.OrderInventory')}</PageHeader>

      {showCreateView ? (
        <CreateOrder
          loading={loading}
          venueItems={venueItems}
          goBack={() => setShowCreateView(false)}
        />
      ) : (
        <InfoWrapper>
          {universe?.requests && universe?.requests?.length > 0 && (
            <OrdersList venueItems={venueItems} />
          )}
          <TextBlock showCreateView={() => setShowCreateView(true)} />
        </InfoWrapper>
      )}
    </Wrapper>
  );
};

export default InventoryOrder;
